import mutations from './employabilityNonValidatedDocuments.mutations'
import actions from './employabilityNonValidatedDocuments.actions'
import getters from './employabilityNonValidatedDocuments.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
